/* global google */
import * as React from "react";
import fieldProps from "./fieldProps";

class AutocompleteCity extends React.Component {
  constructor(props) {
    super(props);
    // Inizializza searchText con il valore passato tramite props o con una stringa vuota
    this.state = {
      searchText: props.value || "", // Usa props.value se disponibile
      sessionToken: null, // Token di sessione per le chiamate
    };
    this.autocomplete = null;
    this.placeChangedListener = null;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.value !== undefined && nextProps.value !== prevState.searchText) {
      return {
        searchText: nextProps.value, // Aggiorna il valore dell'input
      };
    }
    return null; // Nessuna modifica
  }

  componentDidMount() {
    if (window.google && this.state.searchText.length >= 3) {
      this.initializeAutocomplete();
    }
  }
  
  componentWillUnmount() {
    this.cleanup();
  }

  cleanup = () => {
    if (this.placeChangedListener) {
      google.maps.event.removeListener(this.placeChangedListener);
    }
    if (this.autocomplete) {
      google.maps.event.clearInstanceListeners(this.autocomplete);
      this.autocomplete = null;
    }
    this.resetSessionToken();
  };

  initializeAutocomplete = () => {
    const { types = ["(cities)"] } = this.props;
  
    const options = {
      types
    };
  
    // Collega Autocomplete all'input solo se ci sono almeno 3 caratteri
    if (!this.autocomplete && this.state.searchText.length >= 3) {
      this.autocomplete = new google.maps.places.Autocomplete(this.input, options);
  
      // Listener per la selezione di un luogo
      this.placeChangedListener = this.autocomplete.addListener("place_changed", this.handlePlaceChanged);
    }
  };  

  generateSessionToken = () => {
    // Genera un nuovo session token
    const token = new google.maps.places.AutocompleteSessionToken();
    console.log("Session Token Generated:", token);
    this.setState({ sessionToken: token });
  };

  resetSessionToken = () => {
    console.log("Session Token Reset");
    this.setState({ sessionToken: null });
  };

  handlePlaceChanged = () => {
    const { onChange } = this.props;
    const place = this.autocomplete.getPlace();
    if (!place || !place.address_components) return;

    const values = this.extractPlaceDetails(place);
    console.log(values,'--',place);
    
    onChange(values);

    this.setState({ searchText: values.label });

    // Termina la sessione dopo la selezione del luogo
    this.resetSessionToken();
  };

  extractPlaceDetails = (place) => {
    const components = place.address_components || [];
    const details = {
      prov: null,
      countryCode: null,
      country: null,
      label: null,
      cap: null,
      lat: place.geometry?.location.lat() || null,
      lng: place.geometry?.location.lng() || null,
    };

    components.forEach((item) => {
      if (item.types.includes("locality")) {
        details.label = item.long_name || "";
      } else if (item.types.includes('administrative_area_level_3') && !(details.label)) {
        details.label = item.long_name
      } else if (item.types.includes("administrative_area_level_2")) {
        details.prov = item.short_name || "";
      } else if (item.types.includes("country")) {
        details.countryCode = item.short_name || "";
        details.country = item.long_name || "";
      } else if (item.types.includes("postal_code")) {
        details.cap = item.long_name || "";
      }
    });

    return details;
  };

  handleInputChange = (e) => {
    const { onChange } = this.props;
    const inputValue = e.target.value.trim();

    this.setState({ searchText: inputValue }, () => {
      // Inizializza Autocomplete se ci sono almeno 3 caratteri
      if (this.state.searchText.length >= 3 && !this.autocomplete) {
        this.initializeAutocomplete();
      }
    });

    // Genera un nuovo token solo se non esiste già
    if (!this.state.sessionToken) {
      this.generateSessionToken();
    }

    if (this.autocomplete) {
      // Associa il sessionToken corrente all'autocomplete
      this.autocomplete.setOptions({
        sessionToken: this.state.sessionToken,
      });
    }

    onChange({ label: inputValue });
  };

  render() {
    const { name } = this.props;
    const { searchText } = this.state;

    return (
      <>
        <input
          name={name}
          className="form-control input-sm"
          ref={(input) => {
            this.input = input;
          }}
          value={searchText}  // Assicurati che il valore venga gestito correttamente dallo stato
          onChange={this.handleInputChange}
          placeholder="Inserisci una città"
        />
      </>
    );
  }
}

export default fieldProps(AutocompleteCity);